import { logout } from '../../auth'

export async function handleUnauthorizedRequest(status: number) {
  if (status === 401) {
    await logout()
  }
}
